import { Routes } from '@angular/router';
import {
  authGuard,
  PageLoginComponent,
  roleGuard,
  UserRoleEnum,
} from '@rezevent/core';

export const routes: Routes = [
  {
    path: 'login',
    component: PageLoginComponent,
    title: 'Login',
    data: {
      icon: 'event',
      appName: 'Rezevent',
      logoSrc: 'assets/rezevent-combo-primary-800x200.png',
      logoInverseSrc: 'assets/rezevent-combo-inverse-800x200.png',
      tagline: 'Menaxhimi i eventeve\nbëhet i thjeshtë.',
      taglineSubtext:
        'Rezervimet, vendet, menytë dhe pagesat — gjithçka në një vend.',
      welcomeTitle: 'Mirë se erdhët',
      welcomeSubtitle: 'Hyni në llogarinë tuaj për të vazhduar',
      submitLabel: 'Hyr',
      emailError: 'Shkruani një email të vlefshëm',
      passwordError: 'Fjalëkalimi duhet të ketë të paktën 8 karaktere',
    },
  },
  {
    path: '',
    loadComponent: () =>
      import('./page-dashboard/page-dashboard.component').then(
        c => c.PageDashboardComponent
      ),
    canActivate: [authGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'events-calendar',
      },
      {
        path: 'profile',
        loadComponent: () =>
          import('./page-profile/page-profile.component').then(
            c => c.ProfileComponent
          ),
        title: 'profile',
      },
      {
        path: 'events-calendar',
        loadComponent: () =>
          import('./page-events/page-events.component').then(
            c => c.PageEventsComponent
          ),
        title: 'Events',
      },
      {
        path: 'events-list',
        loadComponent: () =>
          import('./page-event-list/page-event-list.component').then(
            c => c.PageEventListComponent
          ),
        title: 'Events',
      },
      {
        path: 'menu',
        loadComponent: () =>
          import('./page-menu/page-menu.component').then(
            c => c.PageMenuComponent
          ),
        title: 'Menu',
      },
      {
        path: 'venues',
        loadComponent: () =>
          import('./page-venues/page-venues.component').then(
            c => c.PageVenuesComponent
          ),
        title: 'Venues',
      },
      {
        path: 'users',
        loadComponent: () =>
          import('./page-users/page-users.component').then(
            c => c.PageUsersComponent
          ),
        title: 'Users',
        canActivate: [roleGuard(UserRoleEnum.manager)],
      },
    ],
  },
  { path: '**', redirectTo: '' },
];
